import React, { Component } from 'react';
import { SkyLightStateless } from 'react-skylight';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';

import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb } from 'react-bootstrap';
import { UI_HEIGHT } from '../Common/constants';
import ContentWrapper from '../Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import genericRadioFilter from '../Common/genericRadioFilter';
import EditRouteModal from '../../containers/Dispatch/EditRouteModal';
import NewRouteModal from '../../containers/Dispatch/NewRouteModal';
import EditRoutePrinterModal from './EditRoutePrinterModal';

class EditRoutes extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      customers: {
        rows: [],
        sortColumn: null,
        sortDirection: null,
        filters: null,
        filteredRows: [],
        selectedRow: null,
      },
      allRoutes: {},
      customersWithStops: {},
      day: 'All',
      newRouteOpen: false,
      editRouteOpen: false,
      editRoutePrinterOpen: false,
      selectedRoute: '',
      selectedDay: '',
      selectedCustomer: '',
    };
    this.handleResize = this.handleResize.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
    this.addNewRoute = this.addNewRoute.bind(this);
    this.openNewRouteModal = this.openNewRouteModal.bind(this);
    this.closeNewRouteModal = this.closeNewRouteModal.bind(this);
    this.openEditRouteModal = this.openEditRouteModal.bind(this);
    this.closeEditRouteModal = this.closeEditRouteModal.bind(this);
  }

  dayDict = {
    MonStop: 'MonRoute',
    TuesStop: 'TuesRoute',
    WedStop: 'WedRoute',
    ThursStop: 'ThursRoute',
    FriStop: 'FriStop',
    SatStop: 'SatStop',
    SunStop: 'SunStop',
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.props.fetchRoutes();
    this.props.fetchActiveCustomers();
    this.props.fetchCustomerRoutes(this.state.day);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.customerRoutes && nextProps.customerRoutes !== this.props.customerRoutes) {
      const newCustomerRoutes = [...nextProps.customerRoutes];
      newCustomerRoutes.map((row) => {
        row.MonStop = row.Stops[0].StopNum ? row.Stops[0].StopNum : '-';
        row.MonRoute = row.Stops[0].RouteNum ? row.Stops[0].RouteNum : '-';
        row.TuesStop = row.Stops[1].StopNum ? row.Stops[1].StopNum : '-';
        row.TuesRoute = row.Stops[1].RouteNum ? row.Stops[1].RouteNum : '-';
        row.WedStop = row.Stops[2].StopNum ? row.Stops[2].StopNum : '-';
        row.WedRoute = row.Stops[2].RouteNum ? row.Stops[2].RouteNum : '-';
        row.ThursStop = row.Stops[3].StopNum ? row.Stops[3].StopNum : '-';
        row.ThursRoute = row.Stops[3].RouteNum ? row.Stops[3].RouteNum : '-';
        row.FriStop = row.Stops[4].StopNum ? row.Stops[4].StopNum : '-';
        row.FriRoute = row.Stops[4].RouteNum ? row.Stops[4].RouteNum : '-';
        row.SatStop = row.Stops[5].StopNum ? row.Stops[5].StopNum : '-';
        row.SatRoute = row.Stops[5].RouteNum ? row.Stops[5].RouteNum : '-';
        row.SundayStop = row.Stops[6].StopNum ? row.Stops[6].StopNum : '-';
        row.SundayRoute = row.Stops[6].RouteNum ? row.Stops[6].RouteNum : '-';
      });
      const customers = { ...this.state.customers, rows: newCustomerRoutes };
      if (this.state.day === 'All') {
        this.setState({ customersWithStops: customers });
      }
      this.setState({ customers });
    }

    if (nextProps.routes && nextProps.routes !== this.props.routes) {
      const routes = {
        mon: ['-'],
        tues: ['-'],
        wed: ['-'],
        thurs: ['-'],
        fri: ['-'],
        sat: ['-'],
        sun: ['-'],
      };
      nextProps.routes.map((route) => {
        // routes.push(route.RouteNum);
        if (route.RouteNum.includes('A')) {
          routes.mon.push(String(route.RouteNum));
        } else if (route.RouteNum.includes('B')) {
          routes.tues.push(String(route.RouteNum));
        } else if (route.RouteNum.includes('C')) {
          routes.wed.push(String(route.RouteNum));
        } else if (route.RouteNum.includes('D')) {
          routes.thurs.push(String(route.RouteNum));
        } else if (route.RouteNum.includes('E')) {
          routes.fri.push(String(route.RouteNum));
        } else if (route.RouteNum.includes('F')) {
          routes.sat.push(String(route.RouteNum));
        } else if (route.RouteNum.includes('G')) {
          routes.sun.push(String(route.RouteNum));
        }
      });
      this.setState({ routes }, () => this.setState({ allRoutes: nextProps.routes }));
    }
  }

  handleResize(e) {
    this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton });
  }

  saveRouteEdits(oldRoute, newRoute, email, driverId) {
    this.props.saveRouteEdits(oldRoute, newRoute, email, driverId)
      .then(() => {
        this.props.fetchCustomerRoutes('All');
      });
    this.setState({ editRouteOpen: false, day: 'All' });
  }

  openNewRouteModal() {
    this.setState({ newRouteOpen: true });
  }

  closeNewRouteModal() {
    this.setState({ newRouteOpen: false });
  }

  openEditRouteModal(...args) {
    if (!args[1]) {
      return;
    }
    let selectedDay;
    let selectedRoute;
    let selectedCustomer;
    switch (args[1]) {
      case 'Monday':
        selectedDay = { value: 'Monday', label: 'Monday' };
        selectedRoute = { value: args[0].MonRoute, label: args[0].MonRoute, email: args[0].Stops[0].Email };
        break;
      case 'Tuesday':
        selectedDay = { value: 'Tuesday', label: 'Tuesday' };
        selectedRoute = { value: args[0].TuesRoute, label: args[0].TuesRoute, email: args[0].Stops[1].Email };
        break;
      case 'Wednesday':
        selectedDay = { value: 'Wednesday', label: 'Wednesday' };
        selectedRoute = { value: args[0].WedRoute, label: args[0].WedRoute, email: args[0].Stops[2].Email };
        break;
      case 'Thursday':
        selectedDay = { value: 'Thursday', label: 'Thursday' };
        selectedRoute = { value: args[0].ThursRoute, label: args[0].ThursRoute, email: args[0].Stops[3].Email };
        break;
      case 'Friday':
        selectedDay = { value: 'Friday', label: 'Friday' };
        selectedRoute = { value: args[0].FriRoute, label: args[0].FriRoute, email: args[0].Stops[4].Email };
        break;
      case 'Saturday':
        selectedDay = { value: 'Saturday', label: 'Saturday' };
        selectedRoute = { value: args[0].SatRoute, label: args[0].SatRoute, email: args[0].Stops[5].Email };
        break;
      case 'Sunday':
        selectedDay = { value: 'Sunday', label: 'Sunday' };
        selectedRoute = { value: args[0].SundayRoute, label: args[0].SundayRoute, email: args[0].Stops[6].Email };
        break;
      default:
        break;
    }
    if (selectedRoute && selectedRoute.value === '-') {
      selectedCustomer = { value: args[0].Name, label: args[0].Name };
    }
    this.setState({
      editRouteOpen: true, selectedDay, selectedRoute, selectedCustomer,
    });
  }

  openEditRoutePrinterModal() {
    this.setState({
      editRoutePrinterOpen: true,
    });
  }

  closeEditRouteModal() {
    this.setState({ editRouteOpen: false });
  }

  closeEditRoutePrinterModal = () => {
    this.setState({ editRoutePrinterOpen: false });
  }

  addNewRoute(day) {
    this.props.saveNewRoute(day, this.props.fetchRoutes)
      .then(() => {
        this.props.fetchCustomerRoutes('All');
      });
    this.setState({ newRouteOpen: false, day: 'All' });
  }

  handleOnClick(day) {
    this.setState({ day }, () => { this.props.fetchCustomerRoutes(day); });
  }

  renderCustomerRoutes() {
    if (this.props.customerRoutesIsLoading && !this.props.customerRoutesError) return <Spinner />;
    else if (this.props.customerRoutesError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.customerRoutesError)}</div></ContentWrapper>;

    // Parameters of the react-data-grid
    const tableHeight = (window.innerHeight < 900) ? 545 : 545;

    const getRows = () => Data.Selectors.getRows(this.state.customers);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const customers = Object.assign({}, this.state.customers, { sortColumn, sortDirection });
      this.setState({ customers });
    };

    const handleFilterChange = (filter) => {
      const filteredRows = [...this.state.customers.rows];
      const newFilters = Object.assign({}, this.state.customers.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const customers = { ...this.state.customers, filters: newFilters, filteredRows };
      this.setState({ customers });
    };

    const onClearFilters = () => {
      // all filters removed
      const customers = { ...this.state.customers, filteredRows: [], filters: {} };
      this.setState({ customers });
    };

    const handleRowUpdated = () => {
      this.setState({ editRouteOpen: true });
    };

    const RowRenderer = React.createClass({
      PropTypes: {
        onDoubleClick: React.PropTypes.func,
      },
      render() {
        return (
          <div onDoubleClick={() => { this.props.onDoubleClick(this.props); }}>
            <ReactDataGrid.Row
              ref="row"
              {...this.props}
            />
          </div>
        );
      },
    });

    const StopFormatter = React.createClass({
      render() {
        if (this.props.value.StopNum) return <span>{this.props.value.StopNum}</span>;
        return <span>-</span>;
      },
    });

    const RouteFormatter = React.createClass({
      render() {
        if (this.props.value.DispatchRoute_id) return <span>{this.props.value.DispatchRoute_id}</span>;
        return <span>-</span>;
      },
    });

    const MondayRouteFormatter = React.createClass({
      render() {
        if (this.props.value) {
          return (
            <span onDoubleClick={() => { this.props.onDoubleClick(this.props.dependentValues, 'Monday'); }}>
              <span style={{ color: 'blue' }}>{this.props.value}</span>
            </span>
          );
        }
        return <span>-</span>;
      },
    });

    const TuesdayRouteFormatter = React.createClass({
      render() {
        if (this.props.value) {
          return (
            <span onDoubleClick={() => { this.props.onDoubleClick(this.props.dependentValues, 'Tuesday'); }}>
              <span style={{ color: 'royalblue' }}>{this.props.value}</span>
            </span>
          );
        }
        return <span>-</span>;
      },
    });

    const WednesdayRouteFormatter = React.createClass({
      render() {
        if (this.props.value) {
          return (
            <span onDoubleClick={() => { this.props.onDoubleClick(this.props.dependentValues, 'Wednesday'); }}>
              <span style={{ color: 'teal' }}>{this.props.value}</span>
            </span>
          );
        }
        return <span>-</span>;
      },
    });

    const ThursdayRouteFormatter = React.createClass({
      render() {
        if (this.props.value) {
          return (
            <span onDoubleClick={() => { this.props.onDoubleClick(this.props.dependentValues, 'Thursday'); }}>
              <span style={{ color: 'green' }}>{this.props.value}</span>
            </span>
          );
        }
        return <span>-</span>;
      },
    });

    const FridayRouteFormatter = React.createClass({
      render() {
        if (this.props.value) {
          return (
            <span onDoubleClick={() => { this.props.onDoubleClick(this.props.dependentValues, 'Friday'); }}>
              <span style={{ color: 'indigo' }}>{this.props.value}</span>
            </span>
          );
        }
        return <span>-</span>;
      },
    });

    const SaturdayRouteFormatter = React.createClass({
      render() {
        if (this.props.value) {
          return (
            <span onDoubleClick={() => { this.props.onDoubleClick(this.props.dependentValues, 'Saturday'); }}>
              <span style={{ color: 'rebeccapurple' }}>{this.props.value}</span>
            </span>
          );
        }
        return <span>-</span>;
      },
    });

    const SundayRouteFormatter = React.createClass({
      render() {
        if (this.props.value) {
          return (
            <span onDoubleClick={() => { this.props.onDoubleClick(this.props.dependentValues, 'Sunday'); }}>
              <span style={{ color: 'purple' }}>{this.props.value}</span>
            </span>
          );
        }
        return <span>-</span>;
      },
    });

    const MondayStopFormatter = React.createClass({
      render() {
        if (this.props.value) return <span style={{ color: 'blue' }}>{this.props.value}</span>;
        return <span>-</span>;
      },
    });

    const TuesdayStopFormatter = React.createClass({
      render() {
        if (this.props.value) return <span style={{ color: 'royalblue' }}>{this.props.value}</span>;
        return <span>-</span>;
      },
    });

    const WednesdayStopFormatter = React.createClass({
      render() {
        if (this.props.value) return <span style={{ color: 'teal' }}>{this.props.value}</span>;
        return <span>-</span>;
      },
    });

    const ThursdayStopFormatter = React.createClass({
      render() {
        if (this.props.value) return <span style={{ color: 'green' }}>{this.props.value}</span>;
        return <span>-</span>;
      },
    });

    const FridayStopFormatter = React.createClass({
      render() {
        if (this.props.value) return <span style={{ color: 'indigo' }}>{this.props.value}</span>;
        return <span>-</span>;
      },
    });

    const SaturdayStopFormatter = React.createClass({
      render() {
        if (this.props.value) return <span style={{ color: 'rebeccapurple' }}>{this.props.value}</span>;
        return <span>-</span>;
      },
    });

    const SundayStopFormatter = React.createClass({
      render() {
        if (this.props.value) return <span style={{ color: 'purple' }}>{this.props.value}</span>;
        return <span>-</span>;
      },
    });

    // Column difinition
    const columns = [
      {
        key: 'Name',
        name: <Translate value="customer_name" />,
        resizable: true,
        sortable: true,
        width: 200,
        filterable: true,
      },
      {
        key: 'CustomerNum',
        name: <Translate value="customer_number" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: 'MonRoute',
        name: <Translate value="mon_route" />,
        resizable: true,
        sortable: true,
        width: 60,
        filterable: true,
        formatter: <MondayRouteFormatter onDoubleClick={this.openEditRouteModal} />,
        getRowMetaData: row => row,
      },
      {
        key: 'MonStop',
        name: <Translate value="mon_stop" />,
        resizable: true,
        sortable: true,
        width: 50,
        filterable: true,
        formatter: MondayStopFormatter,
      },
      {
        key: 'TuesRoute',
        name: <Translate value="tue_route" />,
        resizable: true,
        sortable: true,
        width: 60,
        filterable: true,
        formatter: <TuesdayRouteFormatter onDoubleClick={this.openEditRouteModal} />,
        getRowMetaData: row => row,
      },
      {
        key: 'TuesStop',
        name: <Translate value="tue_stop" />,
        resizable: true,
        sortable: true,
        width: 50,
        filterable: true,
        formatter: TuesdayStopFormatter,
      },
      {
        key: 'WedRoute',
        name: <Translate value="wed_route" />,
        resizable: true,
        sortable: true,
        width: 60,
        filterable: true,
        formatter: <WednesdayRouteFormatter onDoubleClick={this.openEditRouteModal} />,
        getRowMetaData: row => row,
      },
      {
        key: 'WedStop',
        name: <Translate value="wed_stop" />,
        resizable: true,
        sortable: true,
        width: 50,
        filterable: true,
        formatter: WednesdayStopFormatter,
      },
      {
        key: 'ThursRoute',
        name: <Translate value="thu_route" />,
        resizable: true,
        sortable: true,
        width: 60,
        filterable: true,
        formatter: <ThursdayRouteFormatter onDoubleClick={this.openEditRouteModal} />,
        getRowMetaData: row => row,
      },
      {
        key: 'ThursStop',
        name: <Translate value="thu_stop" />,
        resizable: true,
        sortable: true,
        width: 50,
        filterable: true,
        formatter: ThursdayStopFormatter,
      },
      {
        key: 'FriRoute',
        name: <Translate value="fri_route" />,
        resizable: true,
        sortable: true,
        width: 60,
        filterable: true,
        formatter: <FridayRouteFormatter onDoubleClick={this.openEditRouteModal} />,
        getRowMetaData: row => row,
      },
      {
        key: 'FriStop',
        name: <Translate value="fri_stop" />,
        resizable: true,
        sortable: true,
        width: 50,
        filterable: true,
        formatter: FridayStopFormatter,
      },
      {
        key: 'SatRoute',
        name: <Translate value="sat_route" />,
        resizable: true,
        sortable: true,
        width: 60,
        filterable: true,
        formatter: <SaturdayRouteFormatter onDoubleClick={this.openEditRouteModal} />,
        getRowMetaData: row => row,
      },
      {
        key: 'SatStop',
        name: <Translate value="sat_stop" />,
        resizable: true,
        sortable: true,
        width: 50,
        filterable: true,
        formatter: SaturdayStopFormatter,
      },
      {
        key: 'SunRoute',
        name: <Translate value="sun_route" />,
        resizable: true,
        sortable: true,
        width: 60,
        filterable: true,
        formatter: <SundayRouteFormatter onDoubleClick={this.openEditRouteModal} />,
        getRowMetaData: row => row,
      },
      {
        key: 'SunStop',
        name: <Translate value="sun_stop" />,
        resizable: true,
        sortable: true,
        width: 50,
        filterable: true,
        formatter: SundayStopFormatter,
      },
    ];

    return (
      <Row>
        <Col xs={12} id="EditRoutes-dataGrid1">
          <div style={{ maxWidth: '99%' }}>
            <ReactDataGrid
              rowKey="Customer_id"
              onGridSort={handleGridSort}
              onAddFilter={handleFilterChange}
              toolbar={<Toolbar enableFilter />}
              enableCellSelect
              columns={columns}
              rowHeight={25}
              headerRowHeight={50}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              // rowRenderer={<RowRenderer onDoubleClick={this.openEditRouteModal} />}
              minHeight={tableHeight}
              // onRowUpdated={handleRowUpdated}
              onClearFilters={onClearFilters}
            />
          </div>
        </Col>
      </Row>
    );
  }

  render() {
    const newRouteModal = (<Translate value="new_route" />);
    const editRouteModal = (<Translate value="edit_routes" />);
    const createNewRouteDialogStyle = {
      width: '500px',
      marginLeft: '-10%',
    };
    const createEditRouteDialogStyle = {
      width: '1200px',
      height: '650px',
      marginTop: '-330px',
      marginLeft: '-30%',
    };
    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="dispatch" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="edit_routes" />
          </Breadcrumb.Item>
        </Breadcrumb>

        <Grid id="disptach-edit-routes">
          {/* <h1><Translate value="edit_routes" /></h1> */}
          <Row>
            <Col xs={12}>
              <Panel id="date-range-picker" className="form-horizontal">
                <Row>
                  <Col xs={1}>
                    <h3 className="filter-title"><Translate value="filter" /><span className="colon">:</span></h3>
                  </Col>
                  <Col xs={11}>
                    {
                      genericRadioFilter({
                        content: [
                          {
                            option: 'All',
                            id: 'all-radio-filter',
                            name: 'dayFilterRadios',
                            labelName: 'all',
                          },
                          {
                            option: 'Monday',
                            id: 'mon-radio-filter',
                            name: 'dayFilterRadios',
                            labelName: 'mon',
                          },
                          {
                            option: 'Tuesday',
                            id: 'tues-radio-filter',
                            name: 'dayFilterRadios',
                            labelName: 'tues',
                          },
                          {
                            option: 'Wednesday',
                            id: 'wed-radio-filter',
                            name: 'dayFilterRadios',
                            labelName: 'wed',
                          },
                          {
                            option: 'Thursday',
                            id: 'thu-radio-filter',
                            name: 'dayFilterRadios',
                            labelName: 'thu',
                          },
                          {
                            option: 'Friday',
                            id: 'fri-radio-filter',
                            name: 'dayFilterRadios',
                            labelName: 'fri',
                          },
                          {
                            option: 'Saturday',
                            id: 'sat-radio-filter',
                            name: 'dayFilterRadios',
                            labelName: 'sat',
                          },
                          {
                            option: 'Sunday',
                            id: 'sun-radio-filter',
                            name: 'dayFilterRadios',
                            labelName: 'sun',
                          },
                        ],
                        value: this.state.day,
                        handleOnClick: this.handleOnClick,
                        type: 'buttons',
                      })
                    }
                  </Col>
                </Row>
              </Panel>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <Panel className="position-relative" id="routes-table">
                <ButtonToolbar className="table-buttons">
                  {/* {this.renderSaveResults()} */}
                  <Button
                    bsStyle="primary"
                    onClick={() => { this.openNewRouteModal(); }}
                  >
                    <em className="fa fa-plus" /><Translate value="add_new_route" />
                  </Button>
                  <Button
                    bsStyle="warning"
                    onClick={() => { this.openEditRouteModal(null, 'all'); }}
                  >
                    <em className="fa fa-pencil" /><Translate value="edit_route" />
                  </Button>
                  <Button
                    bsStyle="warning"
                    onClick={() => { this.openEditRoutePrinterModal(null, 'all'); }}
                  >
                    <em className="fa fa-pencil" /><Translate value="edit_printer" />
                  </Button>
                </ButtonToolbar>
                { this.renderCustomerRoutes() }
              </Panel>
            </Col>
          </Row>
        </Grid>
        <SkyLightStateless
          dialogStyles={createNewRouteDialogStyle}
          isVisible={this.state.newRouteOpen}
          onCloseClicked={() => { this.closeNewRouteModal(); }}
          title={newRouteModal}
        >
          <NewRouteModal
            routes={this.state.allRoutes}
            close={this.closeNewRouteModal}
            action={(day) => { this.addNewRoute(day); }}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createEditRouteDialogStyle}
          isVisible={this.state.editRouteOpen}
          onCloseClicked={() => { this.closeEditRouteModal(); }}
          title={editRouteModal}
        >
          <EditRouteModal
            allRoutes={this.state.allRoutes}
            customersWithStops={this.state.customersWithStops}
            allCustomers={this.props.allCustomers}
            selectedRoute={this.state.selectedRoute}
            selectedDay={this.state.selectedDay}
            selectedCustomer={this.state.selectedCustomer}
            close={this.closeEditRouteModal}
            action={(oldRoute, newRoute, email, driverId) => { this.saveRouteEdits(oldRoute, newRoute, email, driverId); }}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createEditRouteDialogStyle}
          isVisible={this.state.editRoutePrinterOpen}
          onCloseClicked={() => { this.closeEditRoutePrinterModal(); }}
          title={editRouteModal}
        >
          <EditRoutePrinterModal
            close={this.closeEditRoutePrinterModal}
          />
        </SkyLightStateless>
      </ContentWrapper>
      //---------------
      // End HTML
      //---------------
    );
  }
}

export default EditRoutes;



// WEBPACK FOOTER //
// ./master/jsx/components/Dispatch/editRoutes.jsx